(function(){
  console.log('load page contact js');
  var data = {}
  var isLoading = false
  var form , thankEl;
  var EMAIL_REGEX = /^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/
  // start
  window.onload = function(){
    form = $("#mopio_contact_form_wejxg")
    thankEl = $("#mopio_contact_thankyou_1kxqt")
    initThankyou();
    initTypeSelect();
    initMarketplaceSelect();
    bindSubmit();
  }

  var beforeSend = function (xhr) {
    xhr.setRequestHeader ("Authorization", "Basic " + btoa("1VxUnq2Kl5NiCGQpxv6:X" ));
  }

  var initThankyou =function(){
    thankEl.find('.back').click(function(e){
      showThankyou(false)
      resetForm()
      e.preventDefault()
    })
  }
  var initTypeSelect = function(){
    form.find("#select_type .default_option").click(function(){
      $(this).parent().toggleClass("active");
    })
    
    form.find("#select_type .option").click(function(){

      var optionValue = $(this).find("span").text().trim();
      data.type = optionValue
      
      $("#select_type .default_option span").text(optionValue);
      $(this).parents(".select_wrap").removeClass("active");
    })
  }
  var initMarketplaceSelect = function(){
    form.find("#select_marketplace .default_option").click(function(){
      $(this).parent().toggleClass("active");
    })
    
    form.find("#select_marketplace .option").click(function(){

      var optionValue = $(this).find("span").text().trim();
      data.marketplace = optionValue
      
      $("#select_marketplace .default_option span").text(optionValue);
      $(this).parents(".select_wrap").removeClass("active");
    })
  }
  var collectFormData = function(){
    var value = form.serializeArray();
    $.each(value, function (index, item) {
      data[item.name] = item.value;
    });
    data.message = form.find("textarea[name=message]").val()
  }

  var validateFields = function(){
 
    // validate name
    if(!data.name){
      form.find("input[name$='name']").parent().addClass('require')
      return false
    }else{
      form.find("input[name$='name']").parent().removeClass('require')
    }

    //validate email
    if(!data.email){
      form.find("input[name$='email']").parent().addClass('require')
      return false
    }else{
      form.find("input[name$='email']").parent().removeClass('require')
    }
    if(!EMAIL_REGEX.test(data.email)){
      form.find("input[name$='email']").parent().addClass('email-invalid')
      return false
    }else{
      form.find("input[name$='email']").parent().removeClass('email-invalid')
    }
    
    // validate number
    if(!data.contactNumber ){
      form.find('.contact_number_wrap').addClass('require')
      return false
    }else{
      form.find('.contact_number_wrap').removeClass('require')
    }
    var isSGNumber = /^((0065)|(65))?\d{8}$/.test(data.contactNumber)
    var isUSNumber = /^(1?)\d{10}$/.test(data.contactNumber)
    if(!isSGNumber && !isUSNumber){
      form.find('.contact_number_wrap').addClass('phone-invalid')
      return false
    }else{
      form.find('.contact_number_wrap').removeClass('phone-invalid')
    }

     // validate select_type
    if(!data.type || data.type.indexOf('Select') === 0){
      form.find('#select_type').addClass('require')
      return false
    }else{
      form.find('#select_type').removeClass('require')
    }
    // if(!data.marketplace || data.marketplace.indexOf('Select') === 0){
    //   form.find('#select_marketplace').addClass('require')
    //   return false
    // }else{
    //   form.find('#select_marketplace').removeClass('require')
    // }
    if(!data.marketplace){
      data.marketplace = "Mopio.com"
    }

    
    // validate message
    if(!data.message){
      form.find("textarea[name=message]").parent().addClass('require')
      return false
    }else{
      form.find("textarea[name=message]").parent().removeClass('require')
    }


    return true
  }

  function format(data){
    var arr = []
    var keys = Object.keys(data)
    for(var i in keys){
      var key = keys[i]
      if(key){
        var keyName = key.slice(0,1).toUpperCase()+key.slice(1)
        arr.push(keyName+" : <br/>"+data[key])
      }
    }
    return arr.sort().join('<br/><br/>')
  }
  function showThankyou(show){
    if(show){
      form.addClass('hidden')
      thankEl.removeClass('hidden')
    }else{
      form.removeClass('hidden')
      thankEl.addClass('hidden')
    }
  }


  function resetForm(){
    data = {}
    form[0].reset()
  }


  function startLoading(){
    isLoading = true
    form.find('.spinner').removeClass('hidden')
    form.find('.submit-btn').addClass('hidden')
    // console.log(isLoading)
  }

  function stopLoading(){
    isLoading = false
    form.find('.spinner').addClass('hidden')
    form.find('.submit-btn').removeClass('hidden')
  }

  var bindSubmit = function(){
    form.submit(function(event){
      event.preventDefault();
      if(isLoading){
        return
      }
      var isValid = true
      collectFormData();
      isValid = validateFields()
//       console.log(isValid)
      if(isValid){
        startLoading()
        
        setTimeout(_=>{
          $.ajax({
            type:'post',
            url: "https://mopio.freshdesk.com/api/v2/tickets",
            contentType:"application/json",
            dataType: 'json',
            async: false,
            data: JSON.stringify({
              "subject": "Contact-us / "+data.type,
              "description": format(data),
              "email": data.email,
              "status":2,
              "priority":1,
              "group_id":48000617191,    
              "type":data.type,
               "custom_fields":{
                 //"cf_issue_type":data.type,
                 //"type" : data.type,
                 //"cf_contact_number": data.contactNumber,
                  //"cf_last_name":data.name,
                  "cf_channel" : data.marketplace,
                  "cf_order_id": data.orderNumber,
              }
            }),
            success: function (result){
              stopLoading()
              showThankyou(true)
            },
            error: function(err){
              console.log(err)
              stopLoading()
            },
            beforeSend:beforeSend
          });
        },10)
      }
      
    })
  }

  

})()


